import Services from './Services.js';

/*
 * Contact
 *
 * Who a phone call reaches.
 *
 * On a replicated website that is the dealership whose site it is, and we know
 * it before the customer has said a word. On the Support Center there is no
 * dealership, so it is the home office, and finding a customer's own dealership is
 * what the lookup is for.
 *
 * >>> THE HOME OFFICE NUMBER IS UNCONFIRMED. <<<
 *
 * It was lifted from the Aqua Link storefront config, the only support number
 * anywhere in these projects. Whether it is the right desk for somebody with a
 * twenty year old MasterGuard alarm is not something the code can know. Confirm
 * it, or replace it, and set `confirmed` to true. Until then the app warns in
 * development on every load.
 *
 * Set the number to null and the call option disappears on its own: the
 * escalation guards on it and goes straight to the written form. Nothing has to
 * be edited anywhere else, and no screen ever offers a number that is not real.
 */

const HOME_OFFICE = {
  hours: 'Monday to Friday, 8am to 5pm Central',
  phone_number: '(972) 393-5500'
};
const Contact = {
  confirmed: false,
  forBrand: (brand, lookup) => {
    // The dealership whose site this is. No lookup needed, no ambiguity.
    let dealership = Services.dealership();
    if (dealership?.phone_number) {
      return {
        hours: dealership.hours || null,
        name: dealership.name,
        phone_number: dealership.phone_number,
        role: 'dealership'
      };
    }

    // A dealership the lookup found, for brands whose policy reaches one.
    if (brand?.escalation === 'dealership_then_home_office' && lookup?.dealership?.phone_number) {
      return {
        hours: null,
        name: lookup.dealership.name,
        phone_number: lookup.dealership.phone_number,
        role: 'dealership'
      };
    }
    if (!HOME_OFFICE.phone_number) {
      return null;
    }
    return {
      hours: HOME_OFFICE.hours,
      name: brand ? `${brand.name} support` : 'Support',
      phone_number: HOME_OFFICE.phone_number,
      role: 'home_office'
    };
  },
  // Digits only, for the tel: link. (972) 393-5500 dials as 9723935500.
  dialable: phone_number => String(phone_number || '').replace(/[^0-9+]/g, '')
};
export default Contact;